import React from "react";
import styled from "styled-components";
import { FiCheckCircle, FiLayers, FiShield, FiZap, FiBarChart2, FiActivity } from "react-icons/fi";

const TallyCalculas = () => {
  return (
    <Wrapper>
      <HeaderSection>
        <Title>Comprehensive Solutions <br /> FOR ASSESSING AND HIRING THE RIGHT TALENT</Title>
        <Description>
          TallyCalculus is an all-encompassing online assessment platform tailored for corporates, training organizations, educational institutions, universities, colleges, and schools. Leveraging cutting-edge technology and best practices, TallyCalculus delivers a seamless, robust experience, enabling organizations to identify, evaluate, and nurture top talent, driving career growth and organizational success.
        </Description>
      </HeaderSection>

      <FeaturesSection>
        <FeatureCard>
          <FiCheckCircle size={40} color="#F7AD2B" />
          <FeatureTitle>38+ Years of Trust</FeatureTitle>
          <FeatureDesc>
            With a legacy spanning over three decades, Tally is a brand synonymous with trust and excellence. Our foundation is built on unwavering ethics and best practices, ensuring reliability in every partnership.
          </FeatureDesc>
        </FeatureCard>
        <FeatureCard>
          <FiShield size={40} color="#F7AD2B" />
          <FeatureTitle>Scalability and Security</FeatureTitle>
          <FeatureDesc>
            Leveraging the latest in technology and services, we ensure a robust, scalable system that prioritizes data privacy and security. Our infrastructure is designed to handle large volumes efficiently, safeguarding your data with best-in-class measures.
          </FeatureDesc>
        </FeatureCard>
        <FeatureCard>
          <FiLayers size={40} color="#F7AD2B" />
          <FeatureTitle>Adaptability and Versatility</FeatureTitle>
          <FeatureDesc>
            Our solutions are designed to seamlessly adapt to diverse environments, infrastructure setups, and varying internet speeds. This versatility ensures smooth operations, whether in urban centres or remote areas.
          </FeatureDesc>
        </FeatureCard>
      </FeaturesSection>

      <KeyFeaturesSection>
        <SectionTitle>Key Features Of Our Platform</SectionTitle>
        <FeaturesGrid>
          <FeatureItem>
            <FiActivity size={28} color="#F7AD2B" />
            <FeatureName>Question Bank Management</FeatureName>
          </FeatureItem>
          <FeatureItem>
            <FiZap size={28} color="#F7AD2B" />
            <FeatureName>Powerful Test Taking Experience</FeatureName>
          </FeatureItem>
          <FeatureItem>
            <FiLayers size={28} color="#F7AD2B" />
            <FeatureName>Cross-Platform Support</FeatureName>
          </FeatureItem>
          <FeatureItem>
            <FiBarChart2 size={28} color="#F7AD2B" />
            <FeatureName>Advanced Analytics & Reporting</FeatureName>
          </FeatureItem>
          <FeatureItem>
            <FiShield size={28} color="#F7AD2B" />
            <FeatureName>AI-Based Auto Proctoring</FeatureName>
          </FeatureItem>
        </FeaturesGrid>
      </KeyFeaturesSection>

      <DetailsSection>
        <DetailCard>
          <DetailTitle>Question Bank Management</DetailTitle>
          <DetailList>
            <li>Diverse Question Types: Multiple Choice, True/False, Descriptive, Image-Based, Case Study.</li>
            <li>Bulk Import Capability via Excel.</li>
            <li>Effortless Question Paper Creation with rules, marks, difficulty, and topics.</li>
            <li>Automated Evaluation for most questions.</li>
          </DetailList>
        </DetailCard>
        <DetailCard>
          <DetailTitle>Powerful Test Taking Experience</DetailTitle>
          <DetailList>
            <li>Countdown Timer to track remaining time.</li>
            <li>Section Pallet for easy navigation.</li>
            <li>Question Pallet with color-coded progress.</li>
            <li>Quick Access Toolbar: Next/Prev, Mark for Review, Onscreen Calculator.</li>
          </DetailList>
        </DetailCard>
        <DetailCard>
          <DetailTitle>Cross-Platform Support</DetailTitle>
          <DetailDesc>Conduct assessments on desktop, laptop, or mobile devices—flexibility and convenience ensured.</DetailDesc>
        </DetailCard>
        <DetailCard>
          <DetailTitle>Advanced Analytics & Reporting</DetailTitle>
          <DetailList>
            <li>Detailed insights from question-level to overall performance.</li>
            <li>Data-driven decision making for candidates and testing environments.</li>
            <li>Exportable PDF and Excel reports for sharing and analysis.</li>
          </DetailList>
        </DetailCard>
        <DetailCard>
          <DetailTitle>AI-Based Auto Proctoring</DetailTitle>
          <DetailList>
            <li>Detailed Audit Logs for test session monitoring.</li>
            <li>AI-Driven Monitoring for large-scale exams.</li>
            <li>Remote Proctoring with image capture and recording.</li>
            <li>Reduced need for physical invigilation.</li>
          </DetailList>
        </DetailCard>
      </DetailsSection>

     <CTAButton
  onClick={() => {
    const phone = "919876543210"; // your WhatsApp number with country code
    const message = encodeURIComponent(
      "Hi, I am interested in learning more about Tally Certification."
    );
    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  }}
>
  Get Started
</CTAButton>
    </Wrapper>
  );
};

export default TallyCalculas;

// ---------------- Styled Components ----------------

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 60px 20px; /* increased top padding from 60px → 80px */
  color: ${(props) => props.theme.colors.dark};

  @media (max-width: 768px) {
    padding-top: 100px; /* a bit more on mobile if header is taller */
  }
`;


const HeaderSection = styled.section`
  text-align: center;
  margin-bottom: 60px;
`;

const Title = styled.h1`
  font-size: 2.8rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.secondary};
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  max-width: 850px;
  margin: 20px auto 0 auto;
  color: #555;
  line-height: 1.7;
`;

const FeaturesSection = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  margin-bottom: 60px;
`;

const FeatureCard = styled.div`
  flex: 1 1 280px;
  max-width: 320px;
  text-align: center;
  background: ${(props) => props.theme.colors.light};
  padding: 30px 20px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const FeatureTitle = styled.h3`
  margin-top: 15px;
  font-size: 1.3rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.secondary};
`;

const FeatureDesc = styled.p`
  margin-top: 10px;
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
`;

const KeyFeaturesSection = styled.section`
  margin-bottom: 60px;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 40px;
`;

const FeaturesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: ${(props) => props.theme.colors.light};
  padding: 18px 22px;
  border-radius: 10px;
  box-shadow: 0 5px 18px rgba(0,0,0,0.06);
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;

const FeatureName = styled.span`
  font-size: 1rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.dark};
`;

const DetailsSection = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 60px;
`;

const DetailCard = styled.div`
  background: ${(props) => props.theme.colors.light};
  padding: 25px 20px;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.06);
`;

const DetailTitle = styled.h4`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 12px;
`;

const DetailDesc = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
`;

const DetailList = styled.ul`
  list-style: disc;
  padding-left: 18px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
`;

const CTASection = styled.section`
  text-align: center;
  margin-top: 40px;
`;

const CTAText = styled.h3`
  font-size: 1.6rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 20px;
`;

const CTAButton = styled.button`
  background: ${(props) => props.theme.colors.secondary};
  color: #fff;
  font-size: 1rem;
  padding: 14px 28px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1e7a79;
  }
`;
